/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AziendaFromJSON, AziendaToJSON, } from './Azienda';
import { CategoriaMerceologicaFromJSON, CategoriaMerceologicaToJSON, } from './CategoriaMerceologica';
import { ClienteDtoFromJSON, ClienteDtoToJSON, } from './ClienteDto';
import { FornitoreFromJSON, FornitoreToJSON, } from './Fornitore';
import { OrderCategoryFromJSON, OrderCategoryToJSON, } from './OrderCategory';
import { OrderTypologyFromJSON, OrderTypologyToJSON, } from './OrderTypology';
import { ProjectOrganizationDtoFromJSON, ProjectOrganizationDtoToJSON, } from './ProjectOrganizationDto';
import { SedeFromJSON, SedeToJSON, } from './Sede';
/**
 * @export
 */
export const CicloPassivoFieldsDtoExpenseItemEnumListEnum = {
    Consulenze: 'CONSULENZE',
    Distacco: 'DISTACCO',
    CostiPerLaRivendita: 'COSTI_PER_LA_RIVENDITA',
    Formazione: 'FORMAZIONE',
    GovernanceEControllo: 'GOVERNANCE_E_CONTROLLO',
    Ict: 'ICT',
    Marketing: 'MARKETING',
    ServiziProfessionali: 'SERVIZI_PROFESSIONALI',
    Uffici: 'UFFICI',
    AltriCostiDelPersonaleDiProduzione: 'ALTRI_COSTI_DEL_PERSONALE_DI_PRODUZIONE'
};
/**
 * @export
 */
export const CicloPassivoFieldsDtoOrderContractStatusEnumListEnum = {
    Attivo: 'ATTIVO',
    NonAttivo: 'NON_ATTIVO'
};
/**
 * @export
 */
export const CicloPassivoFieldsDtoOrderProcessingStatusEnumListEnum = {
    Avviato: 'AVVIATO',
    NonAvviato: 'NON_AVVIATO',
    Concluso: 'CONCLUSO'
};
/**
 * @export
 */
export const CicloPassivoFieldsDtoOrderTypeEnumListEnum = {
    Attivo: 'ATTIVO',
    Passivo: 'PASSIVO'
};
/**
 * Check if a given object implements the CicloPassivoFieldsDto interface.
 */
export function instanceOfCicloPassivoFieldsDto(value) {
    return true;
}
export function CicloPassivoFieldsDtoFromJSON(json) {
    return CicloPassivoFieldsDtoFromJSONTyped(json, false);
}
export function CicloPassivoFieldsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'expenseItemEnumList': json['expenseItemEnumList'] == null ? undefined : json['expenseItemEnumList'],
        'orderContractStatusEnumList': json['orderContractStatusEnumList'] == null ? undefined : json['orderContractStatusEnumList'],
        'orderProcessingStatusEnumList': json['orderProcessingStatusEnumList'] == null ? undefined : json['orderProcessingStatusEnumList'],
        'orderTypeEnumList': json['orderTypeEnumList'] == null ? undefined : json['orderTypeEnumList'],
        'orderTypologyList': json['orderTypologyList'] == null ? undefined : (json['orderTypologyList'].map(OrderTypologyFromJSON)),
        'fornitoriList': json['fornitoriList'] == null ? undefined : (json['fornitoriList'].map(FornitoreFromJSON)),
        'aziendaList': json['aziendaList'] == null ? undefined : (json['aziendaList'].map(AziendaFromJSON)),
        'orderCategoryList': json['orderCategoryList'] == null ? undefined : (json['orderCategoryList'].map(OrderCategoryFromJSON)),
        'sedeList': json['sedeList'] == null ? undefined : (json['sedeList'].map(SedeFromJSON)),
        'categoriaMerceologicaList': json['categoriaMerceologicaList'] == null ? undefined : (json['categoriaMerceologicaList'].map(CategoriaMerceologicaFromJSON)),
        'clienteList': json['clienteList'] == null ? undefined : (json['clienteList'].map(ClienteDtoFromJSON)),
        'businessManager': json['businessManager'] == null ? undefined : (json['businessManager'].map(ProjectOrganizationDtoFromJSON)),
        'orderStatusList': json['orderStatusList'] == null ? undefined : json['orderStatusList'],
        'clienteGammaList': json['clienteGammaList'] == null ? undefined : json['clienteGammaList'],
    };
}
export function CicloPassivoFieldsDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'expenseItemEnumList': value['expenseItemEnumList'],
        'orderContractStatusEnumList': value['orderContractStatusEnumList'],
        'orderProcessingStatusEnumList': value['orderProcessingStatusEnumList'],
        'orderTypeEnumList': value['orderTypeEnumList'],
        'orderTypologyList': value['orderTypologyList'] == null ? undefined : (value['orderTypologyList'].map(OrderTypologyToJSON)),
        'fornitoriList': value['fornitoriList'] == null ? undefined : (value['fornitoriList'].map(FornitoreToJSON)),
        'aziendaList': value['aziendaList'] == null ? undefined : (value['aziendaList'].map(AziendaToJSON)),
        'orderCategoryList': value['orderCategoryList'] == null ? undefined : (value['orderCategoryList'].map(OrderCategoryToJSON)),
        'sedeList': value['sedeList'] == null ? undefined : (value['sedeList'].map(SedeToJSON)),
        'categoriaMerceologicaList': value['categoriaMerceologicaList'] == null ? undefined : (value['categoriaMerceologicaList'].map(CategoriaMerceologicaToJSON)),
        'clienteList': value['clienteList'] == null ? undefined : (value['clienteList'].map(ClienteDtoToJSON)),
        'businessManager': value['businessManager'] == null ? undefined : (value['businessManager'].map(ProjectOrganizationDtoToJSON)),
        'orderStatusList': value['orderStatusList'],
        'clienteGammaList': value['clienteGammaList'],
    };
}
